module.exports = __webpack_public_path__ + "img/cencosud.7b3918a7.svg";